export default {
	default: function (numberOfItems) {
		return numberOfItems === 1 ? 0 : 1;
	},
};
